export default {
  brandColor1: '#000000',
  complimentaryColor1: '#f0ede5',
  brandColor2: '#000000',
  complimentaryColor2: '#f0ede5',
};
